import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import styled from "styled-components";

export const Container = styled.div`
  display: block;
  color: #008c6b;
`;

export const MenuContainer = styled.div`
  display: block;
  padding: 0 10px;
  white-space: nowrap;

  .row {
    flex-wrap: nowrap;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  > Button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 158px;
    height: 29px;
    padding: 0 8px 0 10px;
    color: white;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    background-color: ${props => (props.className === "option-selected" ? props.theme.orangeBackground : "#AFAFAF")};

    &:hover {
      background-color: ${props => (props.className === "option-selected" ? props.theme.orangeBackground : "#A0A0A0")};
      border: ${props =>
        props.className === "option-selected" ? "1px solid " + props.theme.orangeBackground : "1px solid #A0A0A0"};
    }

    &:focus {
      background-color: ${props => (props.className === "option-selected" ? props.theme.orangeBackground : "#A0A0A0")};
      border: ${props =>
        props.className === "option-selected" ? "1px solid " + props.theme.orangeBackground : "1px solid #A0A0A0"};
    }
  }

  > div {
    font-size: 12px;
    background-color: #e4e4e4;
  }

  > .dropdown-toggle::after {
    display: none;
  }

  .svg-inline--fa.fa-w-14 {
    width: 16px;
    height: 16px;
  }
`;

export const OptionContainer = styled.div`
  margin-bottom: 5px;
`;

export const StyledCol = styled(Col)`
  .form-check,
  .form-check-input,
  .form-check-label {
    cursor: pointer;
  }
`;

export const StyledCheckbox = styled(Form.Check)`
  color: gray;
  font-weight: 600;
  cursor: pointer;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-left: 8px;
`;
